var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "currentColor",
    strokeOpacity: 0.6,
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8074 6.77147L16.8647 5.23284C16.4711 4.59319 15.6108 4.37709 14.9334 4.74878L14.4666 4.99946C13.5239 5.50945 12.3523 4.8698 12.3523 3.84116V3.33117C12.3523 2.59644 11.7207 2 10.9428 2H9.05725C8.27925 2 7.64772 2.59644 7.64772 3.33117V3.84116C7.64772 4.8698 6.47612 5.50945 5.53337 4.99946L5.06659 4.74878C4.38927 4.37709 3.52888 4.60183 3.13531 5.23284L2.19256 6.77147C1.79898 7.41113 2.03695 8.22366 2.70512 8.59535L3.17193 8.84603C4.11468 9.35602 4.11468 10.644 3.17193 11.154L2.70512 11.4046C2.0278 11.7763 1.79898 12.5889 2.19256 13.2285L3.13531 14.7671C3.52888 15.4068 4.38927 15.6229 5.06659 15.2512L5.53337 15.0005C6.47612 14.4905 7.64772 15.1302 7.64772 16.1588V16.6688C7.64772 17.4036 8.27925 18 9.05725 18H10.9428C11.7207 18 12.3523 17.4036 12.3523 16.6688V16.1588C12.3523 15.1302 13.5239 14.4905 14.4666 15.0005L14.9334 15.2512C15.6108 15.6229 16.4711 15.3982 16.8647 14.7671L17.8074 13.2285C18.201 12.5889 17.963 11.7763 17.2949 11.4046L16.8281 11.154C15.8854 10.644 15.8854 9.35602 16.8281 8.84603L17.2949 8.59535C17.9722 8.22366 18.201 7.40248 17.8074 6.77147Z",
    stroke: "currentColor",
    strokeOpacity: 0.6,
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.db75d371e84d2d38ee1ad3e86cef0870.svg";
export { ForwardRef as ReactComponent };